import React from 'react'
import "./Ece.css"

import image2 from "../../assets2/nwimage3.jpg"

import { Link } from 'react-router-dom'

const Ece = () => {
  return (
    <div className='overallece'> 
      <h1>Multi purpose agri robot</h1>
      <p>Our Multi-Purpose Agriculture Robot powered by IoT technology is designed to revolutionize 
        modern farming. Equipped with smart sensors, it can perform tasks like seeding, spraying, soil 
        monitoring, and weed detection with precision. The robot collects real-time data on soil moisture, 
        temperature, and humidity, optimizing irrigation and reducing water waste. With remote control and 
        automation, farmers can operate it from anywhere via a mobile app. The AI-powered system detects plant
         diseases early, improving crop health. GPS navigation enables autonomous movement across fields, 
         reducing labor costs. The integration of solar power ensures energy efficiency and sustainability. 
         Our IoT-based agri-robot enhances productivity, 
        reduces costs, and supports smart farming for a greener future</p>
        <div className='eceimg'>
          <img src={image2} alt="" className='eceinnerimg'/>  
        </div>
       <div className='hrbtns'>
        <hr />
        <button className='buttonforlink'> <Link to="/projects" className='spllink2'>Back to projects</Link></button>
       </div>
    </div>
   
  )
}

export default Ece